import _ from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  FormControl as MuiFormControl,
  InputLabel,
  Box,
  useMediaQuery,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

import TextInput from "../toolkit/TextInput";
import Select from "../toolkit/Select";
import RadioButtons from "../toolkit/RadioButtons";
import CheckboxGroup from "../toolkit/CheckboxGroup";
import theme from "../themes/baseTheme";
import "../styles/FormControl.css";

import axios from "../utils/fvAxios";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/system";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
export default function FormControlLinked({
  fieldId,
  label,
  inputType,
  items,
  labelPositioning = "vertical",
  fieldPositioning,
  disabled,
  placeHolder,
  classes,
  buttonTypeReferenceValue,
  Pqid,
  Triger,
  reset,
  checked,

  TableReferenceField,
  TableReference,
  TableRefFieldValueDisplay,
  Reference,
  hasUnsavedChanges,
  setValidate,
  isInsideChecklist,
  linkToData,
  userResponse,
  field,
  questionColor,
  questionColorAnswer,
  languageId,
  // setRequired,
  ...props
}) {
  labelPositioning = labelPositioning === "vertical" ? "column" : "row";
  const largeScreen = useMediaQuery(theme.breakpoints.up("sm"));
  if (!largeScreen || isInsideChecklist) labelPositioning = "column";

  const [selectOptions, setSelectOptions] = useState([]);
  const [_userResponse, setUserResponse] = useState(userResponse);
  const navigate = useNavigate();

  useEffect(() => {
    if (inputType === "select") {
      if (Reference) {
        let whereExp = "";
        if (
          Reference?.qcTableReference == "BiddingInterests" ||
          Reference?.qcTableReference == "ClaycoBiddingInterests"
        ) {
          whereExp ="&whereExp=Status=1"+
          "&languageId=" +
          languageId
        }
        axios
          .get(
            "/Prequalification/TableReferenceFieldOptions?tableReference=" +
              TableReference +
              "&tableReferenceField=" +
              TableReferenceField +
              "&tableRefFieldValueDisplay=" +
              TableRefFieldValueDisplay +
              whereExp
          )
          .then((res) => {
            setUserResponse(
              res?.data?.data?.find((x) => x.value == userResponse)?.key
            );
            setSelectOptions(
              res?.data?.data?.map((r) => ({ value: r.value, text: r.key }))
            );
          });
      } else {
        const selectOptions = (items || []).map(({ id, value, text }) => ({
          value: value || id,
          text,
        }));
        setSelectOptions(selectOptions);
      }
    }
  }, [items, inputType]);

  const [error, setError] = useState();
  const [trg, setTrg] = useState(true);

  function handleChange(arg) {
    const _inputType = "text"; //TODO For Linked questions it will be always input text
    props?.handleChange?.(
      ["select"].includes(_inputType)
        ? arg
        : ["checkbox"].includes(_inputType)
        ? arg.target.checked == true
          ? "true"
          : "false"
        : arg.target.value
    );
  }

  useEffect(() => {
    setError("");
  }, [reset]);

  const [view, setView] = useState(true);
  const Viewed = () => {
    Triger(view);
    setView((view) => !view);
  };

  return (
    <>
      <div questionId={fieldId}>
        <MuiFormControl
          className={`form-control ${labelPositioning} ${classes} ${fieldPositioning}`}
          disabled={disabled}
          sx={{ flexDirection: labelPositioning, display: !view ? "none" : "" }} //TODO:-we add display
          component={inputType === "checkbox" ? "fieldset" : undefined}
        >
          <Box className="label-container d-flex">
            <InputLabel
              className={`input-label ${
                props.isBold
                  ? "font-weight-bold text-wrap input-label"
                  : "text-wrap input-label"
              } `}
            >
              {label}
              {/* {field?.required && <sup>*</sup>} */}
              {props.required && <sup>*</sup>}
            </InputLabel>
          </Box>
          <Box className="label-container d-flex">
            {linkToData.expectedValue && (
              <InputLabel className="text-wrap">
                <span className="py-2">{linkToData.expectedValue}</span>
                {linkToData.expectedValue && " / Has "}
              </InputLabel>
            )}
            <InputLabel className="text-wrap rounded" sx={{ color: "black" }}>
              {_userResponse == questionColorAnswer &&
              questionColor == "Red" ? (
                <span className="bg-clr-red2 p-2 text-white">
                  {_userResponse ? _userResponse : " No Data"}
                </span>
              ) : (
                <>
                {/* <span>{_userResponse ?field?.options[0]?.text : "No Data"}                
                
                {(_userResponse+"").toLowerCase()==="true"?<CheckBoxIcon style={{color:"green"}}/>:<CancelIcon style={{color:"red"}}/>}

                </span> */}
                <span className="mx-1">{_userResponse ? _userResponse : "No Data"}</span>
                </>
              )}
          
            </InputLabel>
          </Box>
          {linkToData.expectedValue && (
            <TextInput
              placeholder={linkToData.commentPlaceholder}
              {...props}
              handleChange={handleChange}
            />
          )}
        </MuiFormControl>
      </div>
    </>
  );
}

FormControlLinked.propTypes = {
  /**
   * Label
   */
  label: PropTypes.string,
  /**
   * Label positioning relative to input box - vertical / horizontal
   */
  labelPositioning: PropTypes.string,
  /**
   *  Input type - text, number etc
   */
  inputType: PropTypes.string,
  /**
   * List of options if inputType is select or checkbox or radio
   */
  items: PropTypes.arrayOf(PropTypes.object),
};

FormControlLinked.defaultProps = {
  inputType: "text",
  disabled: false,
};
